import { configureStore,combineReducers } from '@reduxjs/toolkit';
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';

import user from "../redux/slice/user"
import branch from "../redux/slice/branch"
import form from "../redux/slice/form"
import modals from "../redux/slice/modals";
import common from '../redux/slice/common';
import propertySearch from "../redux/slice/property-search"

const reducers = combineReducers({
	user: user,
	branch: branch,
	form: form,
	modals: modals,
	common : common,
	propertySearch: propertySearch,
});

const createNoopStorage = () => {
	return {
		getItem() {
			return Promise.resolve(null);
		},
		setItem(value) {
			return Promise.resolve(value);
		},
		removeItem() {
			return Promise.resolve();
		},
	};
};

const storage = typeof window !== 'undefined' ? createWebStorage('local') : createNoopStorage();

const persistConfig = {

	key: 'signatureRoot',
	storage,
	timeout: null,
	blacklist: ['form', 'propertySearch']
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
	reducer: persistedReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}),
});

export default store;
